import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Input from './Input';

const InputLarge = ({ hasSymbol, ...props }) => (
  <Input extraClassName={classnames('input-large', { 'has-symbol pl5-sm': hasSymbol })} {...props} />
);

InputLarge.propTypes = {
  hasSymbol: PropTypes.bool
};

InputLarge.defaultProps = {
  hasSymbol: false
};

export default InputLarge;
